import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { c as _c } from "react-compiler-runtime";
/* istanbul ignore file */
// ignoring since this will be replaced with the store selector MFE soon
import PropTypes from 'prop-types';
import { formatCurrency } from '@nike/ux-tread-currency';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import getWebShellClientLocale from "../../../state/redux-replacement/get-webshellclient-locale";
function ShipOfferingsHeaderMessage(t0) {
  var $ = _c(3);
  var price = t0.price;
  var localeData = getWebShellClientLocale();
  var t1;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      stringKey: "free",
      primaryValue: "Free",
      description: "Message to display when the price from the service comes back as 0 (zero)."
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  var freePrice = useI18nString(t1);
  var localeProps = {
    country: localeData === null || localeData === void 0 ? void 0 : localeData.country,
    currency: localeData === null || localeData === void 0 ? void 0 : localeData.currency,
    localeForCurrency: localeData === null || localeData === void 0 ? void 0 : localeData.hreflang
  };
  var t2 = "freeOrPricedShipping";
  var t3 = "{price} Shipping";
  var t4 = "A formatted string with locale specific placement of cost and shipping";
  var t5 = price ? formatCurrency(_objectSpread(_objectSpread({}, localeProps), {}, {
    price: "".concat(price)
  })) : freePrice;
  var t6;
  if ($[1] !== t5) {
    t6 = {
      stringKey: t2,
      primaryValue: t3,
      description: t4,
      icuTokens: {
        price: t5
      }
    };
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  var shippingCostMessage = useI18nString(t6);
  return shippingCostMessage;
}
ShipOfferingsHeaderMessage.propTypes = {
  price: PropTypes.number
};
export default ShipOfferingsHeaderMessage;